const productRoute = {
  list: '/product/list',
  editor: '/product/editor',
  detail: '/product/detail',
};

const userRoute = {
  list: '/user/list'
};

const categoryRoute = {
  list: '/category/list',
  editor: '/category/editor',
};

const orderRoute = {
  list: '/order/list',
  detail: '/order/detail'
};

export {
  productRoute,
  userRoute,
  categoryRoute,
  orderRoute,
};
